module.exports = __webpack_public_path__ + "img/4a7ab0d.gif";